<!--
   Created by qing on 2021/1/18
   Des: 
-->
<template>
  <div class="install-temp-forward-page" v-if="tempInfo" v-wechat-title="tempInfo.appName">
    <div class="temp-info">
      <div class="title">
        {{tempInfo.appName}}
      </div>
      <div class="des">
        {{tempInfo.appDes}}
      </div>
    </div>

    <div class="temp-qrcode">
      <van-image
        width="240"
        height="240"
        :src="tempInfo.smallProgramCode"/>
      <div v-if="isWexin" class="tips">
        如果点击无效，请长按小程序码识别。
      </div>
    </div>
    <van-button
      v-if="!isWxWork && !isLark && !isWexin"
      style="padding: 0 40px"
      type="primary"
      round
      @click="onClickInstall">
      安装应用
    </van-button>
    <div class="weapp-btn" v-if="isWexin">
      <wx-open-launch-weapp
        id="launch-weapp1"
        username="gh_d6b31e9e9d8b"
        :path="wxPath"
        @launch="onLaunch"
        @error="onError"
      >
        <script type="text/wxtag-template">
          <div style="border-radius: 20px;font-size: 14px; text-align: center; color: #fff; background-color: #4A66FA;border: 1px solid #4A66FA; height: 44px; line-height: 44px;width: 150px;">安装应用</div>
        </script>
      </wx-open-launch-weapp>
    </div>

  </div>
</template>

<script>
  export default {
    data() {
      return {
        copyInput: null,
        tempInfo: null,
        isWxWork: false,
        isLark: false,
        isWexin: false,
        wxPath: ''
      }
    },
    created() {

      this.copyInput = document.createElement('input')
      this.copyInput.setAttribute('type', 'text')
      this.copyInput.readOnly = 'readOnly';
      this.copyInput.contentEditable = 'true';
      this.copyInput.style.position = 'absolute';
      this.copyInput.style.top = document.body.scrollTop;
      this.copyInput.style.zIndex = '-1000';
      document.body.appendChild(this.copyInput);

      this.isWxWork = window.isWxWork
      this.isLark = window.isLark
      this.isWexin = window.isWexin
      if (!window.isWxWork && !window.isLark) {

        this.$store.dispatch('actionWechatTicket', location.href.split('#')[0])
          .then(res => {
            return new Promise((resolve, reject) => {
              console.log('$wx-config', this.$wx)
              this.$wx.config({
                // debug: true,
                appId: res.appId,
                timestamp: res.timestamp,
                nonceStr: res.nonceStr,
                signature: res.signature,
                jsApiList: ['scanQRCode', 'getLocation', 'chooseImage', 'getLocalImgData'],
                openTagList: ['wx-open-launch-weapp'] // 可选，需要使用的开放标签列表，例如['wx-open-launch-app']
              })
              this.$wx.ready(resolve)
              this.$wx.error(reject)
            })
          })
          .catch(err => {
            console.error('wx config error:', err)
          })
      }

      this.$store.dispatch('getTemplateInfo', this.$route.query.tempId)
        .then(res => {
          this.tempInfo = res
          const array = this.tempInfo.wxJumpPath.split('?')
          this.wxPath = `${array[0]}.html?${array[1]}`
          console.log('wxPath',this.wxPath)
          this.$store.dispatch('setPageTitle', this.tempInfo.appName)
        }).catch(console.error)
    },
    methods: {

      onLaunch() {
        console.error('onLaunch')
      },
      onError(err) {
        console.error('onError',err)
      },
      onClickInstall() {

        this.$dialog.confirm({
          title:'提示',
          message: '当前浏览器不支持登录，请复制链接在微信浏览器中打开。',
          confirmButtonText: '复制',
          cancelButtonText: '取消'
        }).then(() => {

          this.copyInput.setAttribute('value', location.href)
          this.copyInput.select()
          const result = document.execCommand(`copy`)
          if (result) {
            this.$toast.success(`复制成功`)
          } else {
            this.$toast.fail(`复制失败`)
          }

        }).catch(action => {
        })
      }
    }
  }
</script>

<style lang="less">

  .install-temp-forward-page {
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;

    .logo-img {
      margin-top: 10px;
      margin-bottom: 20px;
    }

    .temp-info {
      width: 100%;
      background: #fff;
      border: 0 solid #e0e2e5;
      box-shadow: 0 0 10px 0 rgba(0,0,0,.04);
      border-radius: 8px;
      max-width: 91.5%;
      margin: 6px auto 0;
      font-family: PingFangSC-Regular,Microsoft YaHei;
      padding: 20px;

      .title {
        text-align: center;
        font-size: 20px;
        line-height: 26px;
        color: #2d3033;
        letter-spacing: 0;
      }

      .des {
        margin: 20px 0;
      }
    }


    .temp-qrcode {
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-top: 40px;

      .van-image {
        margin-bottom: 30px;
      }

      .tips {
        font-size: 12px;
        color: #7F8389;
        margin-bottom: 10px;
      }
    }

    .weapp-btn {
      height: 44px;
      line-height: 44px;
      width: 150px;
    }
  }
</style>